"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LumiaActivityTestType = exports.LumiaActivityNoValueTypes = exports.LumiaActivityApiValueType = exports.LumiaActivityOriginTypes = exports.LumiaAlertValues = exports.LumiaExternalActivityCommandTypes = exports.LumiaActivityCommandTypes = void 0;
// Any type of activity that can come in through the app. Anything that changes colors or accessories should be here
var LumiaActivityCommandTypes;
(function (LumiaActivityCommandTypes) {
    LumiaActivityCommandTypes["TEST"] = "test";
    LumiaActivityCommandTypes["ALERT"] = "alert";
    LumiaActivityCommandTypes["CHAT"] = "chat";
    LumiaActivityCommandTypes["DIRECT"] = "direct";
    LumiaActivityCommandTypes["MIDI"] = "midi";
    LumiaActivityCommandTypes["OSC"] = "osc";
    LumiaActivityCommandTypes["MQTT"] = "mqtt";
    LumiaActivityCommandTypes["ARTNET"] = "artnet";
    LumiaActivityCommandTypes["LIGHTS_OFF"] = "lights-off";
    LumiaActivityCommandTypes["RGB_COLOR"] = "rgb-color";
    LumiaActivityCommandTypes["HEX_COLOR"] = "hex-color";
    LumiaActivityCommandTypes["CHAT_COMMAND"] = "chat-command";
    LumiaActivityCommandTypes["CHAT_MATCH"] = "chat-match";
    LumiaActivityCommandTypes["TWITCH_POINTS"] = "twitch-points";
    LumiaActivityCommandTypes["TWITCH_POINTS_OUTPUT"] = "twitch-points-output";
    LumiaActivityCommandTypes["TWITCH_EXTENSION"] = "twitch-extension";
    LumiaActivityCommandTypes["TROVO_SPELLS"] = "trovo-spells";
    LumiaActivityCommandTypes["STUDIO_SCENE"] = "studio-scene";
    LumiaActivityCommandTypes["STUDIO_ANIMATION"] = "studio-animation";
    LumiaActivityCommandTypes["STUDIO_THEME"] = "studio-theme";
    LumiaActivityCommandTypes["SET_FUZE"] = "set-fuze";
    LumiaActivityCommandTypes["START_FUZE"] = "start-fuze";
    LumiaActivityCommandTypes["STOP_FUZE"] = "stop-fuze";
    LumiaActivityCommandTypes["TOGGLE_FUZE"] = "toggle-fuze";
    LumiaActivityCommandTypes["TO_DEFAULT"] = "to-default";
    LumiaActivityCommandTypes["SET_LUMIA"] = "set-lumia";
    LumiaActivityCommandTypes["START_LUMIA"] = "start-lumia";
    LumiaActivityCommandTypes["STOP_LUMIA"] = "stop-lumia";
    LumiaActivityCommandTypes["TOGGLE_STREAMMODE"] = "toggle-stream-mode";
    LumiaActivityCommandTypes["START_STREAMMODE"] = "start-stream-mode";
    LumiaActivityCommandTypes["STOP_STREAMMODE"] = "stop-stream-mode";
    LumiaActivityCommandTypes["CLEAR_QUEUE"] = "clear-queue";
    LumiaActivityCommandTypes["CHATBOT_MESSAGE"] = "chatbot-message";
    LumiaActivityCommandTypes["TTS"] = "tts";
    LumiaActivityCommandTypes["COMMUNITY_TEST"] = "community-test";
    LumiaActivityCommandTypes["UPDATE_VARIABLE_VALUE"] = "update-variable-value";
    LumiaActivityCommandTypes["GET_VARIABLE_VALUE"] = "get-variable-value";
    LumiaActivityCommandTypes["SPOTIFY"] = "send-spotify-command";
    LumiaActivityCommandTypes["VLC"] = "send-vlc-command";
    LumiaActivityCommandTypes["TWITTER"] = "send-twitter-command";
    // Games Glow Command Types
    LumiaActivityCommandTypes["GAMESGLOW_ALERT"] = "gamesglow-alert";
    LumiaActivityCommandTypes["GAMESGLOW_COMMAND"] = "gamesglow-command";
    LumiaActivityCommandTypes["GAMESGLOW_VARIABLE"] = "gamesglow-variable";
    LumiaActivityCommandTypes["GAMESGLOW_VIRTUALLIGHT"] = "gamesglow-virtuallight";
})(LumiaActivityCommandTypes = exports.LumiaActivityCommandTypes || (exports.LumiaActivityCommandTypes = {}));
// Anything that comes through in an external way
var LumiaExternalActivityCommandTypes;
(function (LumiaExternalActivityCommandTypes) {
    LumiaExternalActivityCommandTypes["ALERT"] = "alert";
    LumiaExternalActivityCommandTypes["MIDI"] = "midi";
    LumiaExternalActivityCommandTypes["OSC"] = "osc";
    LumiaExternalActivityCommandTypes["ARTNET"] = "artnet";
    LumiaExternalActivityCommandTypes["RGB_COLOR"] = "rgb-color";
    LumiaExternalActivityCommandTypes["HEX_COLOR"] = "hex-color";
    LumiaExternalActivityCommandTypes["CHAT_COMMAND"] = "chat-command";
    LumiaExternalActivityCommandTypes["TWITCH_POINTS"] = "twitch-points";
    LumiaExternalActivityCommandTypes["TWITCH_EXTENSION"] = "twitch-extension";
    LumiaExternalActivityCommandTypes["TROVO_SPELLS"] = "trovo-spells";
    LumiaExternalActivityCommandTypes["STUDIO_SCENE"] = "studio-scene";
    LumiaExternalActivityCommandTypes["STUDIO_ANIMATION"] = "studio-animation";
    LumiaExternalActivityCommandTypes["STUDIO_THEME"] = "studio-theme";
    LumiaExternalActivityCommandTypes["CHATBOT_MESSAGE"] = "chatbot-messsage";
    LumiaExternalActivityCommandTypes["TTS"] = "tts";
})(LumiaExternalActivityCommandTypes = exports.LumiaExternalActivityCommandTypes || (exports.LumiaExternalActivityCommandTypes = {}));
var LumiaAlertValues;
(function (LumiaAlertValues) {
    LumiaAlertValues["TWITCH_STREAM_LIVE"] = "twitch-streamLive";
    LumiaAlertValues["TWITCH_STREAM_OFFLINE"] = "twitch-streamOffline";
    LumiaAlertValues["TWITCH_FOLLOWER"] = "twitch-follower";
    LumiaAlertValues["TWITCH_SUBSCRIBER"] = "twitch-subscriber";
    LumiaAlertValues["TWITCH_HOST"] = "twitch-host";
    LumiaAlertValues["TWITCH_RAID"] = "twitch-raid";
    LumiaAlertValues["TWITCH_BITS"] = "twitch-bits";
    LumiaAlertValues["TWITCH_REDEMPTION"] = "twitch-redemption";
    LumiaAlertValues["TWITCH_HYPETRAIN_STARTED"] = "twitch-hypetrainStarted";
    LumiaAlertValues["TWITCH_HYPETRAIN_PROGRESSED"] = "twitch-hypetrainProgressed";
    LumiaAlertValues["TWITCH_HYPETRAIN_ENDED"] = "twitch-hypetrainEnded";
    LumiaAlertValues["YOUTUBE_MEMBER"] = "youtube-member";
    LumiaAlertValues["YOUTUBE_SUBSCRIBER"] = "youtube-subscriber";
    LumiaAlertValues["YOUTUBE_SUPERCHAT"] = "youtube-superchat";
    LumiaAlertValues["YOUTUBE_SUPERSTICKER"] = "youtube-supersticker";
    LumiaAlertValues["FACEBOOK_FOLLOWER"] = "facebook-follower";
    LumiaAlertValues["FACEBOOK_REACTION"] = "facebook-reaction";
    LumiaAlertValues["FACEBOOK_STAR"] = "facebook-star";
    LumiaAlertValues["FACEBOOK_SUPPORT"] = "facebook-support";
    LumiaAlertValues["FACEBOOK_SHARE"] = "facebook-share";
    LumiaAlertValues["FACEBOOK_FAN"] = "facebook-fan";
    LumiaAlertValues["GLIMESH_SUBSCRIBER"] = "glimesh-subscriber";
    LumiaAlertValues["GLIMESH_FOLLOWER"] = "glimesh-follower";
    LumiaAlertValues["TROVO_SUBSCRIBER"] = "trovo-subscriber";
    LumiaAlertValues["TROVO_FOLLOWER"] = "trovo-follower";
    LumiaAlertValues["TROVO_SPELL"] = "trovo-spell";
    LumiaAlertValues["TIKTOK_FOLLOWER"] = "tiktok-follower";
    LumiaAlertValues["TIKTOK_LIKE"] = "tiktok-like";
    LumiaAlertValues["TIKTOK_GIFT"] = "tiktok-gift";
    LumiaAlertValues["STREAMLABS_DONATION"] = "streamlabs-donation";
    LumiaAlertValues["STREAMLABS_CHARITY"] = "streamlabs-charity";
    LumiaAlertValues["STREAMLABS_MERCH"] = "streamlabs-merch";
    LumiaAlertValues["STREAMLABS_REDEMPTION"] = "streamlabs-redemption";
    LumiaAlertValues["STREAMLABS_PRIMEGIFT"] = "streamlabs-primegift";
    LumiaAlertValues["STREAMELEMENTS_DONATION"] = "streamelements-donation";
    LumiaAlertValues["STREAMELEMENTS_MERCH"] = "streamelements-merch";
    LumiaAlertValues["STREAMELEMENTS_REDEMPTION"] = "streamelements-redemption";
    LumiaAlertValues["EXTRALIFE_DONATION"] = "extralife-donation";
    LumiaAlertValues["DONORDRIVE_DONATION"] = "donordrive-donation";
    LumiaAlertValues["TILTIFY_DONATION"] = "tiltify-campaignDonation";
    LumiaAlertValues["PAYPAL_PAYMENT_COMPLETE"] = "paypal-paymentComplete";
    LumiaAlertValues["PAYPAL_PAYMENT_DENIED"] = "paypal-paymentDenied";
    LumiaAlertValues["TIPEEESTREAM_DONATION"] = "tipeeestream-donation";
    LumiaAlertValues["TREATSTREAM_TREAT"] = "treatstream-treat";
    LumiaAlertValues["PATREON_PLEDGE"] = "patreon-pledge";
    LumiaAlertValues["OBS_SWITCH_PROFILE"] = "obs-switchProfile";
    LumiaAlertValues["OBS_SWITCH_SCENE"] = "obs-switchScene";
    LumiaAlertValues["OBS_SCENE_ITEM_VISIBILITY"] = "obs-sceneItemVisibility";
    LumiaAlertValues["OBS_SWITCH_TRANSITION"] = "obs-switch-transition";
    LumiaAlertValues["OBS_TRANSITION_BEGIN"] = "obs-transitionBegin";
    LumiaAlertValues["OBS_TRANSITION_END"] = "obs-transitionEnd";
    LumiaAlertValues["OBS_STREAM_STARTING"] = "obs-streamStarting";
    LumiaAlertValues["OBS_STREAM_STOPPING"] = "obs-streamStopping";
    LumiaAlertValues["SLOBS_SWITCH_SCENE_COLLECTION"] = "slobs-switchSceneCollection";
    LumiaAlertValues["SLOBS_SWITCH_SCENE"] = "slobs-switchScene";
    LumiaAlertValues["SLOBS_SCENE_ITEM_VISIBILITY"] = "slobs-sceneItemVisibility";
    LumiaAlertValues["TWITTER_FOLLOWER"] = "twitter-follower";
    LumiaAlertValues["TWITTER_LIKE"] = "twitter-like";
    LumiaAlertValues["TWITTER_RETWEET"] = "twitter-retweet";
    LumiaAlertValues["SPOTIFY_SWITCH_SONG"] = "spotify-switchSong";
    LumiaAlertValues["SPOTIFY_SONG_PLAYED"] = "spotify-songPlayed";
    LumiaAlertValues["SPOTIFY_SONG_PAUSED"] = "spotify-songPaused";
    LumiaAlertValues["VLC_SWITCH_SONG"] = "vlc-switchSong";
    LumiaAlertValues["VLC_SONG_PLAYED"] = "vlc-songPlayed";
    LumiaAlertValues["VLC_SONG_PAUSED"] = "vlc-songPaused";
    LumiaAlertValues["PULSE_HEARTRATE"] = "pulse-heartrate";
    LumiaAlertValues["PULSE_CALORIES"] = "pulse-calories";
    LumiaAlertValues["WOOCOMMERCE_ORDER"] = "woocommerce-order";
})(LumiaAlertValues = exports.LumiaAlertValues || (exports.LumiaAlertValues = {}));
// Where did the Activity Originate from: Chat, alerts, shortcut, api, etc.
var LumiaActivityOriginTypes;
(function (LumiaActivityOriginTypes) {
    LumiaActivityOriginTypes["SYSTEM"] = "system";
    LumiaActivityOriginTypes["ALEXA"] = "alexa";
    LumiaActivityOriginTypes["ALERT"] = "alert";
    LumiaActivityOriginTypes["CHAT"] = "chat";
    LumiaActivityOriginTypes["TWITCH_POINTS"] = "twitch-points";
    LumiaActivityOriginTypes["TWITCH_EXTENSION"] = "twitch-extension";
    LumiaActivityOriginTypes["TROVO_SPELLS"] = "trovo-spells";
    LumiaActivityOriginTypes["API"] = "api";
    LumiaActivityOriginTypes["LUMIASTREAMLINK"] = "lumiastreamlink";
    LumiaActivityOriginTypes["STREAMDECK"] = "streamdeck";
    LumiaActivityOriginTypes["TOUCHPORTAL"] = "touchportal";
    LumiaActivityOriginTypes["GAMESGLOW"] = "gamesglow";
})(LumiaActivityOriginTypes = exports.LumiaActivityOriginTypes || (exports.LumiaActivityOriginTypes = {}));
var LumiaActivityApiValueType;
(function (LumiaActivityApiValueType) {
    LumiaActivityApiValueType[LumiaActivityApiValueType["NO_VALUE"] = 0] = "NO_VALUE";
    LumiaActivityApiValueType[LumiaActivityApiValueType["CUSTOM_VALUE"] = 1] = "CUSTOM_VALUE";
    LumiaActivityApiValueType[LumiaActivityApiValueType["SET_VALUE"] = 2] = "SET_VALUE";
})(LumiaActivityApiValueType = exports.LumiaActivityApiValueType || (exports.LumiaActivityApiValueType = {}));
// Activities that do not need a value
exports.LumiaActivityNoValueTypes = [
    LumiaActivityCommandTypes.CLEAR_QUEUE,
    LumiaActivityCommandTypes.START_FUZE,
    LumiaActivityCommandTypes.START_LUMIA,
    LumiaActivityCommandTypes.START_STREAMMODE,
    LumiaActivityCommandTypes.STOP_FUZE,
    LumiaActivityCommandTypes.STOP_LUMIA,
    LumiaActivityCommandTypes.STOP_STREAMMODE,
    LumiaActivityCommandTypes.TOGGLE_FUZE,
    LumiaActivityCommandTypes.TOGGLE_STREAMMODE,
];
// We'll want to use test types when we're sending a direct activity that doesn't currently have a link
var LumiaActivityTestType;
(function (LumiaActivityTestType) {
    LumiaActivityTestType[LumiaActivityTestType["REACTION"] = 0] = "REACTION";
    LumiaActivityTestType[LumiaActivityTestType["BUILDUPS"] = 1] = "BUILDUPS";
    LumiaActivityTestType[LumiaActivityTestType["ANIMATION"] = 2] = "ANIMATION";
    LumiaActivityTestType[LumiaActivityTestType["THEME"] = 3] = "THEME";
    LumiaActivityTestType[LumiaActivityTestType["SCENE"] = 4] = "SCENE";
})(LumiaActivityTestType = exports.LumiaActivityTestType || (exports.LumiaActivityTestType = {}));
//# sourceMappingURL=activity.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@lumiastream/lumia-types/dist/activity.types.js
// module id = 316
// module chunks = 0